import React, { useState } from 'react';
import { Col, Row } from 'components/Core/Grid';
import FeaturedContent from './FeaturedContent';
import NavigationItem from './NavigationItem';

import { InPageFeaturesV5Container } from './styles';

const InPageFeaturesV5 = ({
  contentful_id: contentfulID,
  featuredItem,
  inPageNavigationItems,
  reversed,
  toggleComponent,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <InPageFeaturesV5Container
      id={`section-${contentfulID}`}
      className={`${toggleComponent ? 'toggle' : ''}`}
    >
      <Row
        spacing={{ sm: 0, md: 12 }}
        className={`featured-content-wrapper ${reversed ? 'reversed' : ''}`}
      >
        <Col xs={24} md={12} className="featured-content-container">
          <FeaturedContent {...featuredItem} />
        </Col>
        <Col xs={24} md={12} className="navigation-items-container">
          <Row type="flex" justify="start" spacing={2} className="navigation-items-row">
            {inPageNavigationItems.map((item, index) => (
              <Col xs={24} xl={12} key={`features-v5--nav-item-col-${index}`}>
                <Row type="flex" justify="start">
                  <Col
                    xs={24}
                    onClick={() => setSelectedIndex(index)}
                    key={`features-v5--nav-item-${index}`}
                    className="navigation-item-container"
                  >
                    <NavigationItem {...item} selected={index === selectedIndex} />
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </InPageFeaturesV5Container>
  );
};

export default InPageFeaturesV5;
